import appleTrust from "@assets/app_store_app_of_the_day_2023_white.webp"
import googleTrust from "@assets/google_editors_choice_2023_white.webp"
import { StarIcon } from "@heroicons/react/24/solid"
import { useTranslation } from "react-i18next"

const REVIEW_KEYS = ["testimonial1", "testimonial2", "testimonial3"]

export default function PaywallReviews() {
  const { t } = useTranslation()

  return (
    <div className="space-y-5">
      <h2 className="vm-heading">
        {t("pages.checkout.trust_element.testimonialsHeading")}
      </h2>

      <div className="grid grid-cols-2 gap-3">
        {[
          {
            label: `App Store · ${t("pages.checkout.trust_element.appStoreRatingsCount")}`,
            rating: t("pages.checkout.trust_element.appStoreRating"),
          },
          {
            label: `Google Play · ${t("pages.checkout.trust_element.googlePlayRatingsCount")}`,
            rating: t("pages.checkout.trust_element.googlePlayRating"),
          },
        ].map((store) => (
          <div
            className="vm-card flex flex-col items-center gap-1 p-4"
            key={store.label}
          >
            <p className="text-3xl font-extrabold text-vm-ink">
              {store.rating}
            </p>
            <div className="flex">
              {[0, 1, 2, 3, 4].map((star) => (
                <StarIcon className="h-4 w-4 text-vm-yellow" key={star} />
              ))}
            </div>
            <p className="text-xs font-medium text-vm-muted">{store.label}</p>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-3 rounded-card bg-vm-ink px-4 py-3 dark:bg-vm-surface">
        <img
          alt="App Store App of the Day"
          className="h-10 w-auto"
          src={appleTrust}
        />
        <img
          alt="Google Play Editors' Choice"
          className="h-10 w-auto"
          src={googleTrust}
        />
      </div>

      <div className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {REVIEW_KEYS.map((reviewKey) => (
          <div
            className="vm-card w-[85%] shrink-0 snap-center p-4"
            key={reviewKey}
          >
            <div className="flex items-center justify-between">
              <p className="font-semibold text-vm-ink">
                {t(`pages.checkout.trust_element.${reviewKey}Author`)}
              </p>
              <div className="flex">
                {[0, 1, 2, 3, 4].map((star) => (
                  <StarIcon className="h-4 w-4 text-vm-yellow" key={star} />
                ))}
              </div>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-vm-muted">
              {t(`pages.checkout.trust_element.${reviewKey}`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
